import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import allIncidentTypes from "../utils/helpers/incidents";
import { getIncidentTypes } from "../api/incident/apiIncidents";

const useIncidentTypes = () => {
  // Use a direct useQuery instead of the useIncident god hook to avoid
  // creating ~15 unnecessary query observers (was the root cause of
  // getAllPickListOptions being called in a loop).
  const {
    isLoading: incidentTypesLoading,
    isError,
    data: incidentTypesData,
  } = useQuery(["incidentTypes"], () => getIncidentTypes(), {
    staleTime: 5 * 60 * 1000, // 5 minutes — incident types rarely change
  });
  const isLoadingOrError = incidentTypesLoading || isError;
  const _incidentTypesData = isLoadingOrError
    ? []
    : incidentTypesData?.data.data;
  const extendedIncidentTypes = useMemo(
    () =>
      allIncidentTypes.reduce((acc: any[], incidentType) => {
        if (!isLoadingOrError) {
          const incidentTypeInfo = _incidentTypesData.find(
            (i: { Name: string }) => i.Name === incidentType.label
          );
          incidentTypeInfo
            ? acc.push({ ...incidentType, flag: incidentTypeInfo.Id })
            : console.error(
                `Incident type ${incidentType.label} not found in incident type data`
              );
        }
        return acc;
      }, []),
    [incidentTypesData, incidentTypesLoading]
  );
  return {
    incidentTypes: extendedIncidentTypes,
    incidentTypesLoading,
  };
};

export default useIncidentTypes;
